/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Product event payload transformed by the backend to the ThisAndThat event collector format.
 */
export type ThisAndThat_CollectEvent = {
    /**
     * Internal event type. `seen` is transformed to `CustomerHasSeenProduct`.
     */
    eventType: ThisAndThat_CollectEvent.eventType;
    /**
     * Optional ThisAndThat event name override.
     */
    name?: string;
    /**
     * Event source forwarded to ThisAndThat.
     */
    source?: string;
    /**
     * GSOA market/house identifier.
     */
    marketId: (number | string);
    /**
     * Product VANR forwarded as `data[].productId`.
     */
    productId: string;
    /**
     * Backward-compatible alternative to `productId`.
     */
    vanr?: string;
    /**
     * FoodRetailor product origin returned in `thisAndThat.origin`.
     */
    origin?: string;
    /**
     * FoodRetailor product origin identifier returned in `thisAndThat.originId`.
     */
    originId?: string | null;
    /**
     * Current product price.
     */
    price: number;
    /**
     * Product price before discount.
     */
    originalPrice?: number | null;
    /**
     * Product price type from product catalog.
     */
    priceType?: string | null;
    /**
     * FoodRetailor strategy identifier returned in `thisAndThat.strategy`.
     */
    strategy?: string | null;
    /**
     * Zero-based FoodRetailor product-card position returned in `thisAndThat.position`.
     */
    position?: number;
    /**
     * Event timestamp. If omitted, backend uses current UTC time.
     */
    dateTime?: string;
    /**
     * Backward-compatible alias for `dateTime`.
     * @deprecated
     */
    timestamp?: string;
};
export namespace ThisAndThat_CollectEvent {
    /**
     * Internal event type. `seen` is transformed to `CustomerHasSeenProduct`.
     */
    export enum eventType {
        SEEN = 'seen',
    }
}

